import classNames from 'classnames';
import Flex from 'components/common/Flex';
import Logo from 'components/common/Logo';
import useApi from 'helpers/api';
import useNotification from 'hooks/useNotification';
import { useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MaskedInput from 'react-text-mask';

const InviteUserForm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const api = useApi();
  const navigate = useNavigate();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const form = useRef(null);
  // State
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const [validated, setValidated] = useState(false);

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (form.current.checkValidity() === false) {
      setValidated(true);
      return;
    }

    try {
      const body = {
        ...formData,
        token: token
      };
      const req = await api.agents.invite(body);
      if (!req.ok) {
        showErrorNotification(req.userMessage);
        return;
      }

      showSuccessNotification('Inscrição finalizada com sucesso');
      navigate('/login');
    } catch (error) {
      showErrorNotification('Erro ao concluir inscrição: ' + error.message);
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Flex
      className="min-vh-100 py-3"
      alignItems="center"
      justifyContent="center"
      direction={'column'}
    >
      <div className="text-center mb-4">
        <Logo width={'250px'} isLink={false} />
      </div>
      <Card style={{ width: '100%', maxWidth: '500px' }} className="mx-3">
        <Card.Header>
          <h3>Finalize sua inscrição</h3>
        </Card.Header>
        <Card.Body>
          <Form
            validated={validated}
            ref={form}
            className={classNames('text-left')}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="agent.firstName">
                <Form.Label>
                  Nome <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nome"
                  name="firstName"
                  autoFocus
                  value={formData.firstName}
                  onChange={handleFieldChange}
                />
                <Form.Control.Feedback type="invalid">
                  Insira um nome.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="agent.lastName">
                <Form.Label>
                  Sobrenome <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Sobrenome"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleFieldChange}
                />
                <Form.Control.Feedback type="invalid">
                  Insira um sobrenome.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Telefone</Form.Label>
              <MaskedInput
                mask={[
                  '(',
                  /[1-9]/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/
                ]}
                placeholder="Telefone"
                name="phone"
                guide={false}
                value={formData.phone}
                onChange={handleFieldChange}
                render={(ref, props) => <Form.Control ref={ref} {...props} />}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label controlId="password">
                Senha <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder={'Digite sua senha'}
                value={formData.password}
                name="password"
                onChange={handleFieldChange}
                type="password"
                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
              />
              <Form.Control.Feedback type="invalid">
                A senha deve ter 8 caracteres, incluindo pelo menos uma letra
                maiúscula, um número e um caractere especial.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label controlId="confirmPassword">
                Confirme a Senha <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                placeholder={'Confirme a senha'}
                value={formData.confirmPassword}
                name="confirmPassword"
                onChange={handleFieldChange}
                type="password"
                pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
              />
              <Form.Control.Feedback type="invalid">
                A senha deve ter 8 caracteres, incluindo pelo menos uma letra
                maiúscula, um número e um caractere especial.
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              type="submit"
              onClick={handleSubmit}
              className="w-100"
              disabled={
                !formData.password ||
                !formData.confirmPassword ||
                formData.password.trim() !== formData.confirmPassword.trim()
              }
            >
              Ativar sua conta
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Flex>
  );
};

export default InviteUserForm;
